const header = document.getElementById("header");
const mobileMenuToggle = document.getElementById("mobileMenuToggle");
const mobileMenuOverlay = document.getElementById("mobileMenuOverlay");
const mobileMenuClose = document.getElementById("mobileMenuClose");

window.addEventListener("scroll", ()=>{

    if(window.scrollY > 100){
        header.classList.add("scrolled");
    }
    else{
        header.classList.remove("scrolled");
    }

});

// Mobile Menu Toggle
mobileMenuToggle.addEventListener("click", ()=>{
    mobileMenuOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
});

mobileMenuClose.addEventListener("click", ()=>{
    mobileMenuOverlay.classList.remove("active");
    document.body.style.overflow = "";
});

// Close mobile menu when clicking on overlay background
mobileMenuOverlay.addEventListener("click", (e)=>{
    if(e.target === mobileMenuOverlay){
        mobileMenuOverlay.classList.remove("active");
        document.body.style.overflow = "";
    }
});

// Close mobile menu when clicking on menu links (not dropdown toggles)
document.querySelectorAll(".mobile-menu a, .mobile-dropdown-menu a").forEach(link => {
    link.addEventListener("click", ()=>{
        mobileMenuOverlay.classList.remove("active");
        document.body.style.overflow = "";
    });
});

// Close mobile menu on escape key
document.addEventListener("keydown", (e)=>{
    if(e.key === "Escape" && mobileMenuOverlay.classList.contains("active")){
        mobileMenuOverlay.classList.remove("active");
        document.body.style.overflow = "";
    }
});

// Mobile Dropdown Toggle
document.querySelectorAll(".mobile-dropdown-toggle").forEach(toggle => {
    toggle.addEventListener("click", ()=>{
        const dropdown = toggle.closest(".mobile-dropdown");
        const isActive = dropdown.classList.contains("active");

        // Close all other dropdowns
        document.querySelectorAll(".mobile-dropdown").forEach(d => {
            d.classList.remove("active");
        });

        // Toggle current dropdown
        if(!isActive){
            dropdown.classList.add("active");
        }
    });
});

// Search Toggle
const searchToggle = document.getElementById("searchToggle");
const searchOverlay = document.getElementById("searchOverlay");
const searchClose = document.getElementById("searchClose");
const searchInput = document.querySelector(".search-input");

if(searchToggle && searchOverlay){
    searchToggle.addEventListener("click", ()=>{
        searchOverlay.classList.add("active");
        document.body.style.overflow = "hidden";
        if(searchInput){
            searchInput.focus();
        }
    });
}

if(searchClose && searchOverlay){
    searchClose.addEventListener("click", ()=>{
        searchOverlay.classList.remove("active");
        document.body.style.overflow = "";
    });
}

// Close search when clicking on overlay background
if(searchOverlay){
    searchOverlay.addEventListener("click", (e)=>{
        if(e.target === searchOverlay){
            searchOverlay.classList.remove("active");
            document.body.style.overflow = "";
        }
    });
}

// Close search on escape key
document.addEventListener("keydown", (e)=>{
    if(e.key === "Escape" && searchOverlay.classList.contains("active")){
        searchOverlay.classList.remove("active");
        document.body.style.overflow = "";
    }
});